import { render, staticRenderFns } from "./ButtonSave.vue?vue&type=template&id=368fbb28&"
import script from "./ButtonSave.vue?vue&type=script&lang=js&"
export * from "./ButtonSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports